// extracted by mini-css-extract-plugin
export var numpadContainer = "_nr-1";
export var phoneButton = "_nr-0";